import { useCallback, useRef } from "react";
import { useCanvasFileIngest } from "./useCanvasFileIngest";

/**
 * Toolbar "U" upload. Owns the persistent hidden file input (rendered in
 * `CanvasPage`, outside any overlay) and routes the picked files through the
 * shared canvas ingestion pipeline, placed at the next free viewport slot.
 */
export function useCanvasToolbarFileUpload(canvasId: string | undefined) {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const { ingestFiles } = useCanvasFileIngest(canvasId);

  const openFilePicker = useCallback(() => {
    fileInputRef.current?.click();
  }, []);

  const handleFileSelect = useCallback(
    async (event: React.ChangeEvent<HTMLInputElement>) => {
      const files = event.target.files;
      if (!files || files.length === 0 || !canvasId) return;
      const fileList = Array.from(files);
      // Reset the input synchronously so re-picking the same file fires change.
      if (fileInputRef.current) fileInputRef.current.value = "";
      await ingestFiles(fileList, {
        placement: { strategy: "flow" },
        errorMessage: "Failed to upload file.",
      });
    },
    [canvasId, ingestFiles],
  );

  return { fileInputRef, openFilePicker, handleFileSelect };
}
